import React from "react";

const DroneStreaming = () => {
  return (
    <div className="panel drone-streaming-panel">
      <div className="panel-header">
        <h3>Drone Streaming</h3>
        <button type="button" className="link-button">View Details</button>
      </div>
      <div className="stream-video-container">
  <video className="stream-video" autoPlay loop muted>
    <source src="/drone_video-output.mp4" type="video/mp4" />
    Your browser does not support the video tag.
  </video>
  <div className="play-overlay"></div>
</div>

    </div>
  );
};

export default DroneStreaming;
